import Aphrodite from './Aphrodite.vue';
import Boris from './Boris.vue';
import Cleopatra from './Cleopatra.vue';
import Deangelo from './Deangelo.vue';
import Euclid from './Euclid.vue';
import Frida from './Frida.vue';

const OffersModalTemplates = {
  aphrodite: Aphrodite,
  boris: Boris,
  cleopatra: Cleopatra,
  deangelo: Deangelo,
  euclid: Euclid,
  frida: Frida,
};
export default OffersModalTemplates;
